// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import axios from 'axios'
import Vuex from 'vuex'
// 校验组件
import VeeValidate, { Validator } from 'vee-validate'
import cn from 'vee-validate/dist/locale/zh_CN'
import url from '@/modules/url'
import api from '@/modules/api.js'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import moment from 'moment'
import sessionstorage from '@/components/cache'
import baseUrl from '@/assets/js/baseUrl.js'
import localStorage from '@/components/cache/localStorage'
// swiper
import 'swiper/dist/css/swiper.css'
import elCascaderMulti from 'el-cascader-multi'
import infiniteScroll from 'vue-infinite-scroll'
import "@/components/utils/banreclick"

Vue.use(infiniteScroll)
Vue.use(elCascaderMulti)
Vue.use(VueDirectiveImagePreviewer)
Vue.prototype.$url = url
    // elementUI初始化
Vue.use(ElementUI)

// Vue.use(VeeValidate)
Vue.use(VeeValidate, {
    events: 'blur'
})

Vue.use(Vuex)
    // 提示语汉化
Validator.locale = 'zh_CN'
Validator.localize(Validator.locale, {
    messages: cn.messages,
    attributes: {
        myName: '登录名',
        loginPassword: '密码'
    }
})

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.moment = moment
Vue.prototype.$loginFront = baseUrl.loginFront
Vue.prototype.$loginBack = baseUrl.loginBack
Vue.prototype.$logOutFront = baseUrl.logOutFront
Vue.prototype.$logOutBack = baseUrl.logOutBack
Vue.prototype.$address = baseUrl.address
Vue.prototype.$photoUrl = baseUrl.photoUrl
Vue.prototype.$staticUrl = baseUrl.staticUrl
Vue.prototype.$getst = baseUrl.getst
Vue.prototype.$uploadImg = baseUrl.uploadImg
Vue.prototype.$deleteImg = baseUrl.deleteImg
Vue.prototype.$linkUrl = baseUrl.linkUrl
Vue.prototype.$downloadUrl = baseUrl.downloadUrl
Vue.prototype.$pageAdressUrl = baseUrl.pageAdressUrl
Vue.prototype.$testLink = baseUrl.testLink
Vue.prototype.$bigUrl = baseUrl.bigUrl
/* eslint-disable no-new */

/**
 * 验证是否需要登录
 */
router.beforeEach((to, from, next) => {
    var homePage = window.location.href.split('/')[0] + '//' + window.location.href.split('/')[1] + window.location.href.split('/')[2]
        // 1.to的页面是否需要登录
    if (to.meta.auth === true) {
        // 1.1 如果需要登录，则去看jtl中是否有ticket
        // 注意  这里分本地调试和线上  本地需要自己放置jtl 线上不需要  这里添加判断
        let jtl = getQueryString('jtl')
        var name = 'jtl'
        var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
        if (jtl !== null && jtl !== '' && jtl !== undefined) {
            delCookie('jtl')
            setCookie('jtl', jtl)
            delCookie('jtlf')
            setCookie('jtlf', 'Basic ' + jtl, null, '/', getTopDomain())
            // window.location.href = homePage + '/pages/salessupport/pc/index.html#/home/user'
            next()
        }
        // 这里面需要注意，jtl可能不是在上面放入cookie中去的，所以直接在cookie里面找，不可以判断url上没有jtl就认为没有jtl
        if (document.cookie.match(reg) !== null && document.cookie.match(reg) !== '') {
            // 1.1.1 如果有ticket，跳转页面

            sessionstorage.session_set('token', getCookie('jtl'))
            // localStorage.session_set('token', getCookie('jtl'))
            setCookie('jtlf', 'Basic ' + getCookie('jtl'), null, '/', getTopDomain())
            
            if (from.path == '/') {
                api.post(url.getExamState, {}, function(res) {
                    if (res.result.isSuccess === true) {
                        let state = res.data.state
                        if (state != '8' && state != '9' && state != '-2') {
                            window.location.href = homePage + baseUrl.address + 'examLogin'
                        }
                    }
                })
            }

            next()
        } else {
            // 1.1.2 如果没有ticket，跳转到登录页，to作为参数
            window.location.href = this.$getst + encodeURIComponent(this.$loginBack + encodeURIComponent(homePage + this.$address + 'home/getContents')) + '&loginUrl=' + encodeURIComponent(homePage + '/pages/salessupport/pc/index.html')
        }
    } else {
        // 1.2 如果不需要登录，则直接跳转目标页
        next()
    }
})

function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) {
        return unescape(r[2])
    }
    return null
}

function setCookie(name, value, expiredays, path, domain) {
    var exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
    document.cookie = name + '=' + escape(value) +
        ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
        + ((path == null) ? '' : ';path=' + path)
        + ((domain == null) ? '' : ';domain=' + domain)
}

function getCookie(key) {
    var arr, reg = RegExp('(^| )' + key + '=([^;]+)(;|$)')
    if (arr = document.cookie.match(reg)) // ["username=liuwei;", "", "liuwei", ";"]
    { return decodeURIComponent(arr[2]) } else { return null }
}

function delCookie(key) {
    var date = new Date()
    date.setTime(date.getTime() - 1)
    var delValue = getCookie(key)
    if (delValue) {
        document.cookie = key + '=' + delValue + ';expires=' + date.toGMTString()
    }
}
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})
function getTopDomain() {
    var domain = document.domain;
    console.log('当前域名：', domain);
    // 计算顶级域名
    var domains = domain.split('.');
    // 查找标记，根据标记，向前一个
    var marks = ['com', 'cn'];
    TOP: 
    for(var m in marks) {
        for(var i = 0; i < domains.length; i++) {
            if(domains[i] == marks[m] && i > 0) {
                domain = '.' + domain.substring(domain.indexOf(domains[i - 1]));
                break TOP;
            }
        }
    }
    console.log('当前顶级域名：', domain);
    return domain;
}


// WEBPACK FOOTER //
// ./src/main.js